"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeaderboardRankTypeEnum = void 0;
var LeaderboardRankTypeEnum;
(function (LeaderboardRankTypeEnum) {
    LeaderboardRankTypeEnum["Default"] = "default";
    LeaderboardRankTypeEnum["Competition"] = "competition";
})(LeaderboardRankTypeEnum = exports.LeaderboardRankTypeEnum || (exports.LeaderboardRankTypeEnum = {}));
//# sourceMappingURL=leaderboard-rank-type-enum.js.map